import Vue from 'vue';
import router from './routers';
import tinyVue from './lib/tinyVue';
import 'dayjs/locale/zh-cn';
import './assets/fonts/iconfont.css';
import './assets/css/oms.css';
import './assets/scss/element-variables.scss';

import Vuex from 'vuex';
import store from './store';
import {init} from './tools/init';
import App from './components/App.vue';
import VueAMap from 'vue-amap';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

init(Vue);

Vue.use(tinyVue);
Vue.use(Vuex);
Vue.use(VueAMap);

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://eb94ae86f9104780be615d09d50416f2@f-log.sinopharm-bio.com/3',
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
    shouldSendCallback: (date) => {// 过滤错误日志
      let filterArray = ['Request failed with status code 401', 'Request failed with status code 502'];
      if (date && date.hasOwnProperty('exception') && date.exception.hasOwnProperty('values') && filterArray.indexOf(date.exception.values[0].value) > -1 || date && date.transaction && date.transaction.indexOf('http://requirejs.org/docs/errors.html') > -1) {
        return false;
      }
      return date;
    }
  });
}

Vue.prototype.xmlBtnList = store.state.xmlBtnList;

window.$mapInit = function () {
  if (window.AMap) return;
  VueAMap.initAMapApiLoader({
    key: '6c228c74ad098018b2e889b27a303a07',
    plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.Geocoder'],
    uiVersion: '1.0',
    v: '1.4.4'
  });
};
window.ENTRANCE = '/entrance';
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
